import {
  Box,
  Container,
  Typography,
  Paper,
  Grid,
  Chip,
  LinearProgress,
  Tooltip,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import {
  LocalFireDepartmentRounded,
  TrendingUpRounded,
} from "@mui/icons-material";
import { jwtDecode } from "jwt-decode";
import { useParams } from "react-router-dom";
import {
  SentimentVerySatisfiedRounded,
  SentimentNeutralRounded,
  SentimentVeryDissatisfiedRounded,
  FavoriteRounded,
  EmojiObjectsRounded,
  ChatRounded,
} from "@mui/icons-material";
import InfoIcon from "@mui/icons-material/Info";
import { palette, theme as colorTheme } from "../../../../Convoze.theme";
import { green } from "@mui/material/colors";
import EmotionAnalysis from "./EmotionAnalysis";

const colors = {
  // bg: "#0b0b0f",
  bg : colorTheme('palette', 'night').value,
  // surface: "#0f1014",
  surface :colorTheme('palette', 'night').value,
  // card: "#111217",
  card:  colorTheme('palette', 'night').value,
  // border: "#1f1f23",
  border :colorTheme('palette', 'night').value,
  text: "#e5e7eb",
  // subtext: "#9aa0a6",
  subtext:colorTheme('palette', 'secondary').value,
  // purple: "#7c3aed",
  purple :colorTheme('palette', 'primary').value,
  // purpleLight: "#a78bfa",
  purpleLight :colorTheme('palette', 'primary').value,
  // green: "#10b981",
  green :colorTheme('palette', 'positive').value,
  // greenTint: "rgba(16,185,129,0.12)",
  greenTine : colorTheme('palette', 'positiveBg').value,
  // dangerTint: "rgba(239,68,68,0.12)",
  dangerTint:colorTheme('palette', 'negativeBg').value,
  // warnTint: "rgba(251,191,36,0.14)",
  warnTint :colorTheme('palette', 'negativeBg').value
};

const PurpleBar = styled(LinearProgress)({
  height: 8,
  borderRadius: 8,
  backgroundColor: "#DAD6D6",
  "& .MuiLinearProgress-bar": {
    borderRadius: 8,
    // background: `linear-gradient(90deg, #6366F1 0%, #9495dcff 50%, #a78bfa 100%)`,
    background:colorTheme('palette', 'primary').value,
  },
});
const Bar = styled(LinearProgress)({
  height: 7,
  borderRadius: 8,
  backgroundColor: "#DAD6D6",
  "& .MuiLinearProgress-bar": {
    borderRadius: 8,
    // background: `linear-gradient(90deg, #6366F1 0%, #9495dcff 50%, #a78bfa 100%)`,
    background:colorTheme('palette', 'primary').value,
  },
});

// export function SectionCard({ icon, title, children, sx,info }) {
//   return (
//     <Paper
//       elevation={0}
//       sx={{
//         flex: 1,
//         border: `1px solid #F1F1F3`,
//         borderRadius: 5,
//         p: { xs: 1.75, sm: 2.25 },
//         ...sx,
//         backgroundColor: "#fdfdffff",
//         boxShadow:
//           "var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)",
//       }}
//     >
//       <Box
//         sx={{
//           display: "flex",
//           alignItems: "center",
//           gap: 1,
//           mb: { xs: 1.5, sm: 2 },
//         }}
//       >
//         <Box
//           aria-hidden
//           sx={{
//             display: "grid",
//             placeItems: "center",
//           }}
//         >
//           {icon}
//         </Box>
//         <Typography
//           variant="h3"
//           sx={{
//             fontWeight: 600,
//             fontSize: "1rem",
//             lineHeight: "1.75rem",
//             color: "#424242",
//           }}
//         >
//           {title}
//           <Tooltip title={info}>
//             <InfoIcon sx={{ fontSize: 18, color: "grey", cursor: "pointer" }} />
//           </Tooltip>
//         </Typography>
//       </Box>
//       {children}
//     </Paper>
//   );
// }



export function SectionCard({ icon, title, children, sx, info }) {
  return (
    <Paper
      elevation={0}
      sx={{
        flex: 1,
        border: `1px solid #F1F1F3`,
        borderRadius: 5,
        p: { xs: 1.75, sm: 2.25 },
        ...sx,
        backgroundColor: "#fdfdffff",
        boxShadow:
          "var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          mb: { xs: 1.5, sm: 2 },
        }}
      >
        <Box
          aria-hidden
          sx={{
            display: "grid",
            placeItems: "center",
          }}
        >
          {icon}
        </Box>

        {/* title */}
        <Typography
          variant="h3"
          sx={{
            fontWeight: 600,
            fontSize: "1rem",
            lineHeight: "1.75rem",
            color: "#424242",
          }}
        >
          {title}
        </Typography>

        <Tooltip title={info}>
          <InfoIcon sx={{ fontSize: 18, color: "grey", cursor: "pointer" }} />
        </Tooltip>
      </Box>

      {children}
    </Paper>
  );
}

export function StatTile({ label, value, color, valueColor }) {
  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: 2,
        p: { xs: 1.75, sm: "1rem" },
        textAlign: "center",
        borderRadius: 5,
        backgroundColor: color,
      }}
    >
      <Typography
        variant="h5"
        sx={{
          fontWeight: 700,
          lineHeight: "2rem",
          mb: 0.5,
          color: valueColor,
          fontSize: "1.5rem",
        }}
      >
        {value}
      </Typography>
      <Typography
        variant="caption"
        sx={{ color: "#424242", lineHeight: "1rem", fontSize: "0.75rem" }}
      >
        {label}
      </Typography>
    </Paper>
  );
}

export function PriorityChip({ priority }) {
  const map = {
    "High Priority": {
      fg: "#fff",
      bg: colors.greenTine,
      // bd: "rgba(239,68,68,0.35)",
      bd : colorTheme('palette', 'positive').value,
    },
    "Medium Priority": {
      fg: colors.text,
      bg: colors.warnTint,
      // bd: "rgba(251,191,36,0.45)",
      bd :colorTheme('palette', 'negative').value,
    },
    "Low Priority": {
      fg: colors.text,
      // bg: "rgba(148,163,184,0.12)",
      bg:colors.dangerTint,
      // bd: "rgba(148,163,184,0.35)",
      bd:colorTheme('palette', 'negative').value,
    },
  };
  const cfg = map[priority] ?? map["Low Priority"];
  return (
    <Chip
      size="small"
      label={priority}
      sx={{
        height: 24,
        bgcolor: cfg.bg,
        color: cfg.fg,
        fontWeight: 700,
        "& .MuiChip-label": { px: 1 },
      }}
    />
  );
}
export function SentimentItem({ icon, color, percent, label, calls, bgcolor }) {
  return (
    <Box sx={{ textAlign: "center" }}>
      <Box
        sx={{
          width: 40,
          height: 40,
          bgcolor: bgcolor,
          boxShadow: `inset 0 0 0 2px ${color}20`,
          color: color,
          borderRadius: "50%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          mx: "auto",
          gap: 1,
        }}
      >
        {icon}
      </Box>
      <Typography
        variant="body1"
        sx={{
          fontWeight: 600,
          fontSize: "1.2rem",
          mt: 2.5,
          lineHeight: "2rem",
        }}
      >
        {percent}
      </Typography>
      <Typography
        variant="caption"
        sx={{
          display: "block",
          // color: "hsl(240 3.8% 46.1%)",
          color :colorTheme('palette', 'secondary').value,
          fontSize: "0.875rem",
          lineHeight: "1.25rem",
        }}
      >
        {label}
      </Typography>
      <Typography
        variant="caption"
        sx={{
          opacity: 0.9,
          // color: "hsl(240 3.8% 46.1%)",
          fontSize: "0.75rem",
          lineHeight: "1rem",
        }}
      >
        {calls}
      </Typography>
    </Box>
  );
}

export function EmotionRow({ name, value }) {
  return (
    <Box sx={{ mb: 1.5 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 0.75,
        }}
      >
        <Typography variant="body2" sx={{}}>
          {name}
        </Typography>
        <Typography variant="caption" sx={{}}>
          {value}%
        </Typography>
      </Box>
      <Bar variant="determinate" value={value} />
    </Box>
  );
}

export default function TeamLeaderboard({ agentProfileData, agentKpisData }) {
  const agentId = useParams();
  const total = agentProfileData?.performanceLeaderborad?.reduce(
    (sum, agent) => sum + agent.averagePerformance,
    0
  );
  const averageScore = total / agentProfileData?.performanceLeaderborad?.length;
  const matchedAgent = agentProfileData?.performanceLeaderborad?.find(
    (agent) => agent?.agentId === agentId?.id
  );

  return (
    <Box sx={{}}>
      {/* Title row */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1.5 }}>
        <Typography
          variant="h2"
          sx={{
            lineHeight: "1.75rem",
            mb: 0.25,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            color: "#424242",
            fontSize: "1.125rem",
            fontWeight: 700,
          }}
        >
          Team Leaderboard
        </Typography>
        <Chip
          size="small"
          icon={
            <LocalFireDepartmentRounded sx={{
              //  color: "#fb923c !important" 
              color :`${colorTheme('palette', 'neutral').value} !important`,
              }} />
          }
          label="Trending"
          sx={{
            height: 22,
            bgcolor: "#E8F9EE",
            // color: "#22C55E",
            color:colorTheme('palette', 'positive').value,
            "& .MuiChip-icon": { ml: 0.5 },
            fontSize: "0.75rem",
            lineHeight: "1rem",
          }}
        />
      </Box>
      {/* Team Ranking */}
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <SectionCard
            icon={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                // color="#6366F1"
                color={colorTheme('palette', 'primary').value}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="lucide lucide-trophy w-5 h-5 text-primary"
                data-lov-id="src/components/dashboard/PerformanceComparison.tsx:46:10"
                data-lov-name="Trophy"
                data-component-path="src/components/dashboard/PerformanceComparison.tsx"
                data-component-line="46"
                data-component-file="PerformanceComparison.tsx"
                data-component-name="Trophy"
                data-component-content="%7B%22className%22%3A%22w-5%20h-5%20text-primary%22%7D"
              >
                <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6"></path>
                <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18"></path>
                <path d="M4 22h16"></path>
                <path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22"></path>
                <path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22"></path>
                <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z"></path>
              </svg>
            }
            title="Team Ranking"
            info="Team Standings – Live Leaderboard"
          >
            <Grid container spacing={2}>
              <Grid item xs={12} md={5}>
                <Paper
                  elevation={0}
                  sx={{
                    textAlign: "center",
                    display: "flex",
                    flexDirection: "column",
                    backgroundColor: "transparent",
                  }}
                >
                  <Typography
                    variant="h4"
                    sx={{
                      // color: "#6366F1",
                      color :colorTheme('palette', 'primary').value,
                      fontWeight: 700,
                      fontSize: "1.8rem",
                    }}
                  >
                    {matchedAgent?.rank !== undefined
                      ? `#${matchedAgent.rank}`
                      : "N/A"}
                  </Typography>
                  <Typography
                    variant="body1"
                    paragraph
                    sx={{
                      color: "#7A7A82",
                      fontSize: "0.875rem",
                      lineHeight: "1.25rem",
                    }}
                  >
                    {`out of ${agentProfileData?.performanceLeaderborad?.length} agents`}
                  </Typography>
                  {/* <Chip
                size="small"
                label="Top 7%"
                sx={{
                  height: 24,
                  alignSelf: "center",
                  fontSize: "0.75rem",
                  backgroundColor: "transparent",
                  border: "0.4px solid #E4E4E7",
                }}
              /> */}
                </Paper>
              </Grid>

              {/* Right: score bar */}
              <Grid item xs={12} md={6}>
                <Paper
                  elevation={0}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 1,
                    backgroundColor: "transparent",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <Typography
                      variant="caption"
                      sx={{
                        color: "#424242",
                        fontWeight: 600,
                        fontSize: "0.85rem",
                        lineHeight: "1.25rem",
                      }}
                    >
                      Your Score
                    </Typography>
                    <Typography
                      variant="subtitle2"
                      sx={{
                        fontWeight: 700,
                        // color: "#6366F1",
                        color :colorTheme('palette', 'primary').value,
                        fontSize: "1.125rem",
                        lineHeight: "1.75rem",
                      }}
                    >
                      {/* {`${matchedAgent?.averagePerformance}%`} */}
                      {matchedAgent?.averagePerformance !== undefined
                        ? `${matchedAgent.averagePerformance}%`
                        : "N/A"}
                    </Typography>
                  </Box>
                  <PurpleBar value={94} variant="determinate" />
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <Typography variant="caption" sx={{ color: "#72727B" }}>
                      Team Avg: {`${averageScore?.toFixed(2)}%`}
                    </Typography>
                    <Typography variant="caption" sx={{ color: "#72727B" }}>
                      Top:{" "}
                      {`${agentProfileData?.performanceLeaderborad[0]?.averagePerformance}%`}
                    </Typography>
                  </Box>
                </Paper>
              </Grid>
              <Grid item xs={12} sm={4}>
                <StatTile
                  label="Your Score"
                  // value={`${matchedAgent?.averagePerformance}%`}
                  value={
                    matchedAgent?.averagePerformance !== undefined
                      ? `#${matchedAgent.averagePerformance}%`
                      : "N/A"
                  }
                  color="#F5F2FB"
                  // valueColor="#6366F1"
                  valueColor={colorTheme('palette', 'primary').value}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <StatTile
                  label="Team Average"
                  value={`${averageScore?.toFixed(2)}%`}
                  color="#F6F6F8"
                  // valueColor="#71717A"
                  valueColor={colorTheme('palette', 'secondary').value}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <StatTile
                  label="Top Performer"
                  value={`${agentProfileData?.performanceLeaderborad[0]?.averagePerformance}%`}
                  color="#E0F1E7"
                  // valueColor="#10B981"
                  valueColor={colorTheme('palette', 'positive').value}
                />
              </Grid>
            </Grid>
          </SectionCard>
        </Grid>
        <Grid item xs={12} md={6}>
          {/* Sentiment Distribution */}
          <SectionCard
            icon={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                // color="#6366F1"
                color={colorTheme('palette', 'primary').value}
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="lucide lucide-brain w-5 h-5 text-primary"
                data-lov-id="src/components/dashboard/SentimentAnalysis.tsx:51:10"
                data-lov-name="Brain"
                data-component-path="src/components/dashboard/SentimentAnalysis.tsx"
                data-component-line="51"
                data-component-file="SentimentAnalysis.tsx"
                data-component-name="Brain"
                data-component-content="%7B%22className%22%3A%22w-5%20h-5%20text-primary%22%7D"
              >
                <path d="M12 5a3 3 0 1 0-5.997.125 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588A4 4 0 1 0 12 18Z"></path>
                <path d="M12 5a3 3 0 1 1 5.997.125 4 4 0 0 1 2.526 5.77 4 4 0 0 1-.556 6.588A4 4 0 1 1 12 18Z"></path>
                <path d="M15 13a4.5 4.5 0 0 1-3-4 4.5 4.5 0 0 1-3 4"></path>
                <path d="M17.599 6.5a3 3 0 0 0 .399-1.375"></path>
                <path d="M6.003 5.125A3 3 0 0 0 6.401 6.5"></path>
                <path d="M3.477 10.896a4 4 0 0 1 .585-.396"></path>
                <path d="M19.938 10.5a4 4 0 0 1 .585.396"></path>
                <path d="M6 18a4 4 0 0 1-1.967-.516"></path>
                <path d="M19.967 17.484A4 4 0 0 1 18 18"></path>
              </svg>
            }
            title="Sentiment Distribution"
            info="Sentiment Distribution Overview"
          >
            <Grid container spacing={2} justifyContent="space-between">
              <Grid item xs={12} sm={4}>
                <SentimentItem
                  icon={<SentimentVerySatisfiedRounded />}
                  // color={"#22C55E"}
                  color={colorTheme('palette', 'positive').value}
                  bgcolor="#E6F7EC"
                  // percent={
                  //   agentKpisData?.sentimentPercentages?.neutral
                  //     ? `${agentKpisData.sentimentPercentages.neutral}%`
                  //     : "0"
                  // }
                  percent={
                    agentKpisData?.sentimentPercentages?.neutral &&
                    !isNaN(agentKpisData.sentimentPercentages.neutral)
                      ? `${agentKpisData.sentimentPercentages.neutral}%`
                      : "0%"
                  }
                  label="Positive"
                  calls="145 calls"
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <SentimentItem
                  icon={<SentimentNeutralRounded />}
                  // color="#FFBF00"
                  color={colorTheme('palette', 'neutral').value}
                  bgcolor="#faf0d4ff"
                  // percent={
                  //   agentKpisData?.sentimentPercentages?.neutral
                  //     ? `${agentKpisData?.sentimentPercentages?.neutral}%`
                  //     : "0"
                  // }
                  percent={
                    agentKpisData?.sentimentPercentages?.neutral &&
                    !isNaN(agentKpisData?.sentimentPercentages?.neutral)
                      ? `${agentKpisData?.sentimentPercentages?.neutral}%`
                      : "0%"
                  }
                  label="Neutral"
                  calls="67 calls"
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <SentimentItem
                  icon={<SentimentVeryDissatisfiedRounded />}
                  // color={"#EF4444"}
                  color={colorTheme('palette', 'negative').value}
                  bgcolor="#f7e8e8ff"
                  // percent={
                  //   agentKpisData?.sentimentPercentages?.negative
                  //     ? `${agentKpisData?.sentimentPercentages?.negative}%`
                  //     : "0"
                  // }
                  percent={
                    agentKpisData?.sentimentPercentages?.negative &&
                    !isNaN(agentKpisData?.sentimentPercentages?.negative)
                      ? `${agentKpisData?.sentimentPercentages?.negative}%`
                      : "0%"
                  }
                  label="Negative"
                  calls="23 calls"
                />
              </Grid>
            </Grid>
          </SectionCard>
        </Grid>

        {/* <Grid item xs={12} md={6}> 
          <SectionCard
            icon={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                // color="#6366F1"
                color={colorTheme('palette', 'primary').value}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="lucide lucide-heart w-5 h-5 text-primary"
                data-lov-id="src/components/dashboard/SentimentAnalysis.tsx:80:10"
                data-lov-name="Heart"
                data-component-path="src/components/dashboard/SentimentAnalysis.tsx"
                data-component-line="80"
                data-component-file="SentimentAnalysis.tsx"
                data-component-name="Heart"
                data-component-content="%7B%22className%22%3A%22w-5%20h-5%20text-primary%22%7D"
              >
                <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"></path>
              </svg>
            }
            title="Emotion Analysis"
            info="Customer Emotion Analysis Summary"
          >
             <EmotionAnalysis emotionAnalysis={agentKpisData?.emotionAnalysis} />


          </SectionCard>
        </Grid> */}

        
        {/* current Emotion Analysis section */}
        <Grid item xs={12} md={6}>
         
          <SectionCard
            icon={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                // color="#6366F1"
                color={colorTheme('palette', 'primary').value}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="lucide lucide-heart w-5 h-5 text-primary"
                data-lov-id="src/components/dashboard/SentimentAnalysis.tsx:80:10"
                data-lov-name="Heart"
                data-component-path="src/components/dashboard/SentimentAnalysis.tsx"
                data-component-line="80"
                data-component-file="SentimentAnalysis.tsx"
                data-component-name="Heart"
                data-component-content="%7B%22className%22%3A%22w-5%20h-5%20text-primary%22%7D"
              >
                <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"></path>
              </svg>
            }
            title="Emotion Analysis"
            info="Customer Emotion Analysis Summary"
          >


            <EmotionRow
              name="Happiness"
              value={
                agentKpisData?.emotionAnalysis?.Happiness
                  ? agentKpisData?.emotionAnalysis?.Happiness
                  : 0
              }
            />
            <EmotionRow
              name="Confidence"
              value={
                agentKpisData?.emotionAnalysis?.Confidence
                  ? agentKpisData?.emotionAnalysis?.Confidence
                  : 0
              }
            />
            <EmotionRow
              name="Calmness"
              value={
                agentKpisData?.emotionAnalysis?.Calmness
                  ? agentKpisData?.emotionAnalysis?.Calmness
                  : 0
              }
            />
            <EmotionRow
              name="Empathy"
              value={
                agentKpisData?.emotionAnalysis?.Empathy
                  ? agentKpisData?.emotionAnalysis?.Empathy
                  : 0
              }
            />

            <EmotionRow
              name="Frustration"
              value={
                agentKpisData?.emotionAnalysis?.Frustration
                  ? agentKpisData?.emotionAnalysis?.Frustration
                  : 0
              }
            />


          </SectionCard>
 
        
          
        </Grid> 


       
        {/* Performance vs Peers */}
        {/* <SectionCard
        icon={
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            color="#6366F1"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="lucide lucide-users w-5 h-5 text-primary"
            data-lov-id="src/components/dashboard/PerformanceComparison.tsx:85:10"
            data-lov-name="Users"
            data-component-path="src/components/dashboard/PerformanceComparison.tsx"
            data-component-line="85"
            data-component-file="PerformanceComparison.tsx"
            data-component-name="Users"
            data-component-content="%7B%22className%22%3A%22w-5%20h-5%20text-primary%22%7D"
          >
            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
            <circle cx="9" cy="7" r="4"></circle>
            <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
            <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
          </svg>
        }
        title="Your Performance"
        sx={{ mt: 2 }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4}>
            <StatTile
              label="Your Score"
              value={`${matchedAgent?.averagePerformance}%`}
              color="#F5F2FB"
              valueColor="#6366F1"
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <StatTile
              label="Team Average"
              value={`${averageScore?.toFixed(2)}%`}
              color="#F6F6F8"
              valueColor="#71717A"
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <StatTile
              label="Top Performer"
              value={`${agentProfileData?.performanceLeaderborad[0]?.averagePerformance}%`}
              color="#E0F1E7"
              valueColor="#10B981"
            />
          </Grid>
          <Grid item xs={12}>
            <Box
              sx={{ display: "flex", alignItems: "center", gap: 1, mt: 0.5 }}
            >
              <TrendingUpRounded sx={{ color: "#10b981", fontSize: 14 }} />
              <Typography
                variant="body2"
                sx={{ color: "#10b981", fontWeight: 600, fontSize: "0.8rem" }}
              >
                +7 points above team average
              </Typography>{" "}
            </Box>
          </Grid>
        </Grid>
      </SectionCard> */}
      </Grid>
    </Box>
  );
}
